import React from 'react'
import { getSoundList, setVolume } from '../../Sounds'
import SoundSelector from './SoundSelector'
import config from 'config'

/**
 * The sound sub-category in the DevTools.
 * Let's the user replace sounds on the fly.
 */
export default class SoundPage extends React.Component {
  state = { open: false }
  /**
   * Creates DOM elements for all available sounds.
   * @param sounds
   * @returns {any[] | Array}
   */
  getSoundSelectors = (sounds) => {
    const soundKeys = Object.keys(sounds)
    const soundControls = soundKeys.map(key => {
      const sound = sounds[key]
      return <SoundSelector soundName={key} key={key} volume={sound._volume} />
    })
    return soundControls || []
  }

  /**
   * Initiates a download to let the user save the
   * current sound settings.
   */
  download = () => {
    const sounds = getSoundList()

    const json = Object.keys(sounds).reduce(function(newObject, key) {
      newObject[key] = sounds[key]._volume || 1
      return newObject
    }, {})
    const { downloadElement } = this

    const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(json))}`

    downloadElement.setAttribute('href', dataStr)
    downloadElement.setAttribute('download', `${config.GAME_CONFIG.GAME_ID}-mix.json`)
    downloadElement.click()
  }

  /**
   * This lets the user upload a file with pre-configured
   * sound settings to the client.
   * @param e
   */
  upload = (e) => {
    const reader = new FileReader()
    reader.onload = this.onReaderLoad
    reader.readAsText(e.target.files[0])
  }

  /**
   * This function will tell the sound component to
   * update the sounds according to the configuration
   * that was uploaded.
   * @param event
   */
  onReaderLoad = (event) => {
    const obj = JSON.parse(event.target.result)
    setVolume(obj)
    setTimeout(() => this.forceUpdate(), 500)
  }

  render() {
    const sounds = getSoundList()
    const soundControls = this.getSoundSelectors(sounds)

    return (
      <div>
        <a ref={e => this.downloadElement = e} style={{ display: 'none' }} />
        <div>
          <div style={{ textAlign: 'center', paddingBottom: '30px' }}>
            <input style={{ marginRight: '15px' }} type="button" value="Download" onClick={this.download} />
            <input type="file" id="selectFiles" onChange={this.upload} />
          </div>
          <div className="devConsolePage">
            {soundControls}
          </div>
        </div>
      </div>
    )
  }
}
